import PageScroller from './Modules/PageScroller';
import ViewVotesClient from './Modules/ViewVotes/ViewVotesClient';
import Dialog from './Modules/Dialog';

class ViewVotesItemList extends ViewVotesClient {
    constructor(removeButtonClassName, removeAllButtonClassName, toggleAllStateButtonClassName, checkBoxClassName, dialogLinkClass) {
        super(toggleAllStateButtonClassName, checkBoxClassName);

        const removeButtons = document.getElementsByClassName(removeButtonClassName);
        for (let i = 0; i < removeButtons.length; i++) {
            removeButtons[i].addEventListener('click', this.removeCheckedItem.bind(this), false);
        }

        const removeAllButtons = document.getElementsByClassName(removeAllButtonClassName);
        for (let i = 0; i < removeAllButtons.length; i++) {
            removeAllButtons[i].addEventListener('click', this.removeAllItem.bind(this), false);
        }

        window.addEventListener('storage', this.updatePage.bind(this));
        this.updatePage();

        new Dialog(dialogLinkClass);
    }
    updatePage() {
        const tableBody = document.querySelector('tbody');
        const items = this.getList(null);

        const count = document.getElementById('count');
        if (!count) throw new Error('count要素が存在しません。');

        const length = items.length;
        count.textContent = length.toString();

        const sectionElement = document.querySelector('section');
        const notFoundElement = document.getElementById('notfound');
        if (!sectionElement || !notFoundElement) throw new Error('');

        if (length === 0) {
            sectionElement.style.display = 'none';
            notFoundElement.setAttribute('aria-hidden', 'false');
            if (tableBody) {
                while (tableBody.firstChild) {
                    tableBody.removeChild(tableBody.firstChild);
                }
            }
        }
        else {
            sectionElement.style.display = 'inherit';
            notFoundElement.setAttribute('aria-hidden', 'true');
            this.createTable(items);
        }
    }

    removeCheckedItem() {
        const items = document.querySelectorAll('.reading-checkbox:checked');

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const id = item.dataset.id;
            if (!id) throw new Error('idカスタムデータ属性が存在しません');

            this._viewVotesManager.remove(id, false);
        }
        this._viewVotesManager.saveToLocal();
        this.updatePage();
    }

    removeAllItem() {
        this._viewVotesManager.removeAll();
        this.updatePage();
    }

    createTable(items) {
        const fragment = document.createDocumentFragment();
        const tableBody = document.querySelector('tbody');
        if (!tableBody) throw new Error('');

        while (tableBody.rows.length > 0) tableBody.deleteRow(0);

        for (const item of items) {

            if (!tableBody.querySelector(`[data-id="${item.id}"]`)) {
                fragment.appendChild(this.createTableRow(item));
            }
        }

        tableBody.appendChild(fragment);
    }

    createTableRow(item) {
        const tableRow = document.createElement('tr');
        tableRow.dataset.id = item.id.toString();
        const numData = document.createElement('td');
        numData.className = 'table-row-num';
        numData.style.whiteSpace = 'nowrap';
        const selectData = document.createElement('td');
        selectData.style.textAlign = 'center';
        const selectBox = document.createElement('input');
        selectBox.className = 'reading-checkbox';
        selectBox.type = 'checkbox';
        selectBox.dataset.id = item.id.toString();
        selectBox.dataset.cat = item.category;
        selectBox.dataset.catOrder = item.categoryOrder.toString();
        selectBox.dataset.refNum = item.refNum;
        selectBox.dataset.refNum2 = item.refNum2;
        selectBox.dataset.docNumString = item.docNumStr;
        selectBox.dataset.docNum = item.docNum.toString();
        selectBox.dataset.docNumBranch1 = item.docNumBranch1.toString();
        selectBox.dataset.docNumBranch2 = item.docNumBranch2.toString();
        selectBox.dataset.docTitle = item.title;
        selectData.appendChild(selectBox);
        const catData = document.createElement('td');
        catData.textContent = item.category;
        catData.style.whiteSpace = 'nowrap';
        const refData = document.createElement('td');
        refData.textContent = item.refNum;
        refData.style.whiteSpace = 'nowrap';
        const docData = document.createElement('td');
        docData.textContent = item.docNumStr;
        const titleData = document.createElement('td');
        titleData.textContent = item.title;
        tableRow.appendChild(numData);
        tableRow.appendChild(selectData);
        tableRow.appendChild(catData);
        tableRow.appendChild(refData);
        tableRow.appendChild(docData);
        tableRow.appendChild(titleData);
        return tableRow;
    }
}
{
    new PageScroller();
    new ViewVotesItemList('remove-btn', 'remove-all-btn', 'check-all-btn', 'reading-checkbox', 'popup-link');
}
